import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';

import { TextField } from '../../../material-ui/TextField';
import { darkFullWhite } from '../../../../service/getMuiThemeStyle';
import { useStyles } from './useStyles';

export const Auth = memo(({ onChange, login, password, dark }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t: translate } = useTranslation();

    return (
        <>
            <TextField
                required={true}
                type="login"
                name="login"
                label={translate('loginPage.login')}
                onChange={onChange}
                value={login}
                fullWidth={true}
                className={classes.field}
                {...((dark || theme.palette.type === 'dark') && {
                    InputProps: {
                        style: {
                            color: darkFullWhite,
                        },
                    },
                })}
                {...(dark && {
                    InputLabelProps: {
                        style: {
                            color: darkFullWhite,
                        },
                    },
                })}
            />
            <TextField
                required={true}
                type="password"
                name="password"
                label={translate('loginPage.password')}
                onChange={onChange}
                value={password}
                fullWidth={true}
                className={classes.field}
                {...((dark || theme.palette.type === 'dark') && {
                    InputProps: {
                        style: {
                            color: darkFullWhite,
                        },
                    },
                })}
                {...(dark && {
                    InputLabelProps: {
                        style: {
                            color: darkFullWhite,
                        },
                    },
                })}
            />
        </>
    );
});
